import { createFileRoute } from '@tanstack/react-router'
import { ClosureQueue } from '@/components/mlro/ClosureQueue'

export const Route = createFileRoute('/mlro/closures')({
    component: MlroClosuresPage,
})

function MlroClosuresPage() {
    return (
        <div className="space-y-6">
            <div>
                <h1 className="text-2xl font-semibold">Account closures</h1>
                <p className="text-muted-foreground text-sm">
                    Compliance-mandated account closures: review the evidence, execute the net-€0
                    close-out on-chain, or dismiss as a false positive with a note.
                </p>
            </div>
            <ClosureQueue />
        </div>
    )
}
